jQuery('document').ready(function($) {
    "use strict";

    $('.product__variation select').niceSelect();
});